import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 6L9 17L4 12", stroke: "#191C1F", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCheck;
